
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M20.576 9.95l-1.383-.3a7.531 7.531 0 00-.445-1.074l.766-1.191a.538.538 0 00-.072-.671l-2.156-2.156a.538.538 0 00-.67-.072l-1.192.766a7.53 7.53 0 00-1.074-.445l-.3-1.383A.538.538 0 0013.524 3h-3.048a.538.538 0 00-.526.424l-.3 1.383c-.369.12-.728.27-1.074.445l-1.191-.766a.538.538 0 00-.671.072L4.558 6.714a.538.538 0 00-.072.67l.766 1.192a7.529 7.529 0 00-.445 1.074l-1.383.3a.538.538 0 00-.424.526v3.048c0 .253.176.472.424.526l1.383.3c.12.369.27.728.445 1.074l-.766 1.191a.538.538 0 00.072.671l2.156 2.156a.538.538 0 00.67.072l1.192-.766c.346.176.705.325 1.074.445l.3 1.383a.538.538 0 00.526.424h3.048a.538.538 0 00.526-.424l.3-1.383c.369-.12.728-.27 1.074-.445l1.191.766a.538.538 0 00.671-.072l2.156-2.156a.538.538 0 00.072-.67l-.766-1.192c.176-.346.325-.705.445-1.074l1.383-.3a.538.538 0 00.424-.526v-3.048a.538.538 0 00-.424-.526zM15.227 12A3.23 3.23 0 0112 15.227 3.23 3.23 0 018.773 12 3.23 3.23 0 0112 8.773 3.23 3.23 0 0115.227 12z","fill":"#fff"}})])
          )
        }
      }
    